import { render, staticRenderFns } from "./InquiryStatuses.vue?vue&type=template&id=1458497a"
import script from "./InquiryStatuses.vue?vue&type=script&lang=js"
export * from "./InquiryStatuses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports